import { memo } from 'react';
import CustomeDateRange from '../../CustomeDateRange';
import dayjs from 'dayjs';

const CustomDateRangePicker = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  width = '100%',
  height = '40px',
  sx,
}) => {
  return (
    <CustomeDateRange
      startDate={fromDate}
      endDate={toDate}
      width={width}
      height={height}
      sx={sx}
      onStartChange={(newValue) => {
        const formatted = newValue && dayjs(newValue).isValid() ? dayjs(newValue).format('YYYY-MM-DD') : '';
        onFromDateChange?.(formatted);
      }}
      onEndChange={(newValue) => {
        const formatted = newValue && dayjs(newValue).isValid() ? dayjs(newValue).format('YYYY-MM-DD') : '';
        onToDateChange?.(formatted);
      }}
    />
  );
};

export default memo(CustomDateRangePicker);
